import { useEffect, useState } from "react";
import api, { dt, errMsg } from "@/api";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");
  const [entity, setEntity] = useState("");
  useEffect(() => {
    let active = true;
    api.get("/audit", { params: { entity: entity || undefined } })
      .then((r) => { if (active) { setRows(r.data); setError(""); } })
      .catch((e) => { if (active) setError(errMsg(e)); });
    return () => { active = false; };
  }, [entity]);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <p className="overline">Güvenlik</p>
        <h1 className="font-display text-4xl font-black tracking-tighter">Denetim Kayıtları</h1>
      </div>
      <select className="brut-input max-w-[240px]" value={entity} onChange={(e) => setEntity(e.target.value)} data-testid="audit-entity-filter">
        <option value="">Tüm varlıklar</option>
        {["party", "request", "supplier_offer", "quote", "operation", "operation_refs", "operation_portal", "charge", "document", "shipment", "user", "leg", "event", "tariff"].map((x) => (
          <option key={x} value={x}>{x}</option>
        ))}
      </select>
      <div className="brut overflow-x-auto" data-testid="audit-table">
        <table className="dense w-full">
          <thead><tr><th>Zaman</th><th>Kullanıcı</th><th>Rol</th><th>İşlem</th><th>Varlık</th><th>Not</th><th>Önceki</th><th>Yeni</th></tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id} className={i % 2 ? "bg-zinc-50" : ""} data-testid={`audit-row-${r.id}`}>
                <td className="whitespace-nowrap text-xs">{dt(r.at)}</td>
                <td className="text-xs">{r.user_email}</td>
                <td className="text-xs uppercase">{r.user_role}</td>
                <td className="font-semibold">{r.action}</td>
                <td className="text-xs">{r.entity}</td>
                <td className="max-w-[260px] text-xs text-zinc-700" title={r.note || ""} data-testid={`audit-note-${r.id}`}>
                  {r.note || "-"}
                </td>
                <td className="max-w-[220px] truncate font-mono text-[11px] text-zinc-500">{r.before ? JSON.stringify(r.before) : "-"}</td>
                <td className="max-w-[220px] truncate font-mono text-[11px] text-zinc-500">{r.after ? JSON.stringify(r.after) : "-"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8} className="py-10 text-center text-zinc-500" data-testid="audit-empty-state">{error || "Kayıt yok."}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
